import { NgModule } from '@angular/core';
import { AppsSharedModule } from '../../apps-shared/apps-shared.module';
import { BaseSharedModule } from '../../shared/base-shared.module';
import { BaseAdministrationShiftFormComponent } from './_components/base-administration-shift-form/base-administration-shift-form.component';
import { BaseAdministrationComponent } from './_components/base-administration/base-administration.component';
import { BaseMasterAddressFormComponent } from './_components/base-master-data/base-master-address-form/base-master-address-form.component';
import { BaseGeneralInfoFormComponent } from './_components/base-master-data/base-general-info-form/base-general-info-form.component';
import { BaseProfileManagementComponent } from './_components/base-profile-management/base-profile-management.component';
import { BaseTermsOfContractSurchargeComponent } from './_components/base-terms-of-contract/base-terms-of-contract-surcharge/base-terms-of-contract-surcharge.component';
import { BaseTermsOfContractComponent } from './_components/base-terms-of-contract/base-terms-of-contract.component';
import { BaseChangeUserPasswordFormComponent } from './_components/base-user-management/base-change-user-password-form/base-change-user-password-form.component';
import { BaseEditPermissionGroupsFormComponent } from './_components/base-user-management/base-edit-permission-groups-form/base-edit-permission-groups-form.component';
import { BaseEditUserFormComponent } from './_components/base-user-management/base-edit-user-form/base-edit-user-form.component';
import { BaseInviteUserFormComponent } from './_components/base-user-management/base-invite-user-form/base-invite-user-form.component';
import { BasePermissionGroupsComponent } from './_components/base-user-management/base-permission-groups/base-permission-groups.component';
import { BaseUserListItemComponent } from './_components/base-user-management/base-user-list-item/base-user-list-item.component';
import { BaseUserManagementComponent } from './_components/base-user-management/base-user-management/base-user-management.component';
import { BaseAdministrationFormComponent } from './_models/base-administration-form';
import { BasePermissionCheckboxTemplateComponent } from './_components/base-user-management/base-permission-checkbox-template/base-permission-checkbox-template.component';
import { BaseAddressFormComponent } from './_components/base-master-data/base-address-form/base-address-form.component';
import { BasePermissionComponent } from './_components/base-user-management/base-permission-groups/permission/base-permission.component';
import { BaseAddPermissionGroupModalComponent } from './_components/base-user-management/base-permission-groups/add-permission-group-modal/base-add-permission-group-modal.component';
import { BasePermissionGroupComponent } from './_components/base-user-management/base-edit-permission-groups-form/permission-group/base-permission-group.component';

@NgModule({
  imports: [BaseSharedModule, AppsSharedModule],
  declarations: [
    BaseAdministrationFormComponent,
    BaseAdministrationComponent,
    BaseUserManagementComponent,
    BasePermissionGroupsComponent,
    BaseUserListItemComponent,
    BaseInviteUserFormComponent,
    BaseEditUserFormComponent,
    BaseEditPermissionGroupsFormComponent,
    BaseTermsOfContractComponent,
    BaseTermsOfContractSurchargeComponent,
    BaseProfileManagementComponent,
    BaseGeneralInfoFormComponent,
    BaseMasterAddressFormComponent,
    BaseAddressFormComponent,
    BaseAdministrationShiftFormComponent,
    BaseChangeUserPasswordFormComponent,
    BasePermissionCheckboxTemplateComponent,
    BasePermissionComponent,
    BaseAddPermissionGroupModalComponent,
    BasePermissionGroupComponent,
  ],
  exports: [
    BaseAdministrationFormComponent,
    BaseAdministrationComponent,
    BaseUserManagementComponent,
    BasePermissionGroupsComponent,
    BaseUserListItemComponent,
    BaseInviteUserFormComponent,
    BaseEditUserFormComponent,
    BaseEditPermissionGroupsFormComponent,
    BaseProfileManagementComponent,
    BaseTermsOfContractComponent,
    BaseTermsOfContractSurchargeComponent,
    BaseAdministrationShiftFormComponent,
    BaseGeneralInfoFormComponent,
    BaseMasterAddressFormComponent,
    BaseAddressFormComponent,
    BaseChangeUserPasswordFormComponent,
    BasePermissionCheckboxTemplateComponent,
    BasePermissionComponent,
    BaseAddPermissionGroupModalComponent,
    BasePermissionGroupComponent,
  ],
})
export class BaseAdministrationModule {}
